module.exports = {
	"intro": [
		{
			"section": "aim",
			"display": "Aim"
		},
		{
			"section": "about",
			"display": "About Us"
		},
		{
			"section": "opening",
			"display": "Opening Hours"
		},
		{
			"section": "librarian",
			"display": "Word of Librarian"
		}
	],
	"suggestion": [
		{
			"name": "purchase",
			"display": "Purchase Suggestion"
		},
		{
			"name": "guideline",
			"display": "Suggestion Guide"
		},
		{
			"name": "security",
			"display": "Security Vulnerability"
		}
	],
	"librarian": [
		{
			"section": "members",
			"display": "Members"
		},
		{
			"section": "join",
			"display": "Join Us"
		}
	],
	"service": [
		{
			"section": "loan",
			"display": "Book Loaning Service"
		},
		{
			"section": "collection",
			"display": "Library Collection"
		},
		{
			"section": "instruction",
			"display": "Instruction"
		},
		{
			"section": "readers",
			"display": "Readers Service"
		},
		{
			"section": "facility",
			"display": "Facility"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/data/nav.json
// module id = 54
// module chunks = 0